import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { identity } from 'ramda';

import { valueAccessorFactory } from '../../helpers/custom-value-provider';
import { hasValue } from '../../util';

@Component({
  selector: 'pcs-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  providers: [
    valueAccessorFactory(FileUploadComponent)
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileUploadComponent implements ControlValueAccessor {
  @Input() disabled = false;
  @Input() icon: string;
  @Input() iconColor = '';
  @Input() permittedFilesText = '';
  @Input() accepts: string[] = [];
  @Input() fileSize: number;

  value: File;
  private onChange = identity;
  private onTouch = () => {
  };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  writeValue(value: File): void {
    this.value = value;
  }

  hasFiles() {
    return hasValue(this.value);
  }

  removeFile() {
    this.value = null;
    this.onChange(this.value);
  }

  addFile(file: File) {
    this.value = file;
    this.onChange(this.value);
    this.onTouch();
  }

}
